import { fetchData } from "@client";

export async function getPolicyArticleQuery() {
  return await fetchData("/article/2");
}
